"use client";

import { useState, useEffect } from "react";
import { Box, Paper, Tabs, Tab, CircularProgress } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PeopleIcon from "@mui/icons-material/People";

import ClientePaqueteDetalle from "../transaccionComponent/ClientePaqueteDetalle.js";
import ClientePaqueteMovimientos from "../transaccionComponent/ClientePaqueteMovimientos.js";
import TablaEntidadCliente from "./TablaEntidadCliente.js";

const GestionClientesTabs = () => {
  const showMainMovimientosTab = false;
  const [tabActiva, setTabActiva] = useState("grupos");
  const [movimientosRefreshTick, setMovimientosRefreshTick] = useState(0);
  const [tabsMontados, setTabsMontados] = useState({
    grupos: true,
    movimientos: false,
    clientes: false,
  });
  const [cargandoGrupos, setCargandoGrupos] = useState(false);

  const handleChangeTab = (event, newValue) => {
    if (newValue === "grupos") {
      setCargandoGrupos(true);
    }
    if (newValue === "movimientos") {
      setMovimientosRefreshTick((prev) => prev + 1);
    }
    setTabActiva(newValue);
    setTabsMontados((prev) => ({
      ...prev,
      [newValue]: true,
    }));
  };

  useEffect(() => {
    if (tabActiva === "grupos" && cargandoGrupos) {
      const timer = setTimeout(() => setCargandoGrupos(false), 400);
      return () => clearTimeout(timer);
    }
  }, [tabActiva, cargandoGrupos]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        width: "100%",
      }}
    >
      <Paper
        elevation={2}
        sx={{
          mx: 2,
          mt: 2,
          mb: 1,
          borderRadius: 2,
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        <Tabs
          value={tabActiva}
          onChange={handleChangeTab}
          aria-label="Tabs gestión de clientes"
          sx={{
            "& .MuiTabs-indicator": {
              height: 3,
            },
          }}
        >
          <Tab
            value="grupos"
            label="Cliente grupos"
            icon={<GroupsIcon />}
            iconPosition="start"
            sx={{
              textTransform: "none",
              minHeight: 56,
              fontWeight: 600,
            }}
          />
          {showMainMovimientosTab && (
            <Tab
              value="movimientos"
              label="Movimientos"
              icon={<ReceiptLongIcon />}
              iconPosition="start"
              sx={{
                textTransform: "none",
                minHeight: 56,
                fontWeight: 600,
              }}
            />
          )}
          <Tab
            value="clientes"
            label="Clientes"
            icon={<PeopleIcon />}
            iconPosition="start"
            sx={{
              textTransform: "none",
              minHeight: 56,
              fontWeight: 600,
            }}
          />
        </Tabs>
      </Paper>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          role="tabpanel"
          hidden={tabActiva !== "grupos"}
          sx={{
            display: tabActiva === "grupos" ? "flex" : "none",
            flexDirection: "column",
            height: "100%",
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          {cargandoGrupos ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 200,
              }}
            >
              <CircularProgress size={48} thickness={4} />
            </Box>
          ) : (
            tabsMontados.grupos && <ClientePaqueteDetalle />
          )}
        </Box>

        {showMainMovimientosTab && (
          <Box
            role="tabpanel"
            hidden={tabActiva !== "movimientos"}
            sx={{
              display: tabActiva === "movimientos" ? "block" : "none",
              height: "100%",
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            {tabsMontados.movimientos && (
              <ClientePaqueteMovimientos refreshTrigger={movimientosRefreshTick} />
            )}
          </Box>
        )}

        <Box
          role="tabpanel"
          hidden={tabActiva !== "clientes"}
          sx={{
            display: tabActiva === "clientes" ? "block" : "none",
            height: "100%",
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          {tabsMontados.clientes && <TablaEntidadCliente embedded />}
        </Box>
      </Box>
    </Box>
  );
};

export default GestionClientesTabs;
